module.exports = __webpack_public_path__ + "media/images/logos/simrad-md-0dc4a2e9c8b886701ccbe785bc0e44c8.png";